export const isAllTabsHidden = (tabsLen: number, localTabsIdsLen: number, allTabsHidden: boolean): boolean => {
  if (tabsLen === localTabsIdsLen) {
    return true;
  } else if (localTabsIdsLen === 0) {
    return false;
  } else {
    return allTabsHidden;
  }
};
